"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcCheckboxConstants = exports.CHECKBOX_CLASS = void 0;
var common_constants_1 = require("../../../common/constants/common-constants");
exports.CHECKBOX_CLASS = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-container-checkbox");
var BcCheckboxConstants = (function () {
    function BcCheckboxConstants() {
    }
    BcCheckboxConstants.CHECKBOX_CLASS = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-container-checkbox");
    BcCheckboxConstants.CHECKBOX_CLASS_DISABLED = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-container-checkbox-disabled");
    BcCheckboxConstants.CHECKBOX_SPAN_CLASS = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-checkbox");
    BcCheckboxConstants.MIXED = "mixed";
    BcCheckboxConstants.CHECKBOX = 'checkbox';
    BcCheckboxConstants.EVT_CLICK = 'click';
    BcCheckboxConstants.ATTR_ID = "id";
    BcCheckboxConstants.ATTR_CHECKED = "checked";
    BcCheckboxConstants.ATTR_ARIA_CHECKED = "aria-checked";
    BcCheckboxConstants.ATTR_ARIA_LABELLEDBY = "aria-labelledby";
    BcCheckboxConstants.ATTR_ARIA_DESCRIBEDBY = "aria-describedby";
    return BcCheckboxConstants;
}());
exports.BcCheckboxConstants = BcCheckboxConstants;
